// Version : 0.0.3
// Author : VISHNU
// LastEdit : Sabari
// Last ADD : Unwanted Redux Clear
// MODFIED DATE : 11-11-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*********************** GET BRANCH OFFICER LIST START *********************/
export const branchOfficerListGet = (listData: any) => {
	const data = {
		GetOfficerListBranchToken: listData,
	};
	const url = `${API_URL}getAllOfficerUserBasedonBranch`;
	return makeApiCall(url, data);
};
/*********************** GET BRANCH OFFICER LIST END *********************/

/*********************** GET OFFICER CENTER LIST START *********************/
export const officerCenterListGet = (listData: any) => {
	const data = {
		GetOfficerListCenterToken: listData,
	};
	const url = `${API_URL}getCenterListBasedOnOfficerBranch`;
	return makeApiCall(url, data);
};
/*********************** GET OFFICER CENTER LIST END *********************/

/*********************** GET LOAN GROUP LIST START *********************/
export const loanGroupListGet = (listData: any) => {
	const data = {
		GetLoanGroupListToken: listData,
	};
	const url = `${API_URL}getGroupBasedLoanIndex`;
	return makeApiCall(url, data);
};
/*********************** GET LOAN GROUP LIST END *********************/

/*********************** UPDATE CHANGE GROUP OFFICER LIST START *********************/
export const ChangeGroupOfficerListUpdate = (listData: any) => {
	const data = {
		ChangeGroupOfficerDataToken: listData,
	};
	const url = `${API_URL}updateGroupOfficer`;
	return makeApiCall(url, data);
};
/*********************** UPDATE CHANGE GROUP OFFICER LIST END *********************/

/*********************** GET BRANCH OFFICER LIST (AutoLoan) START *********************/
export const branchOfficerListGetAutoLoan = (listData: any) => {
	const data = {
		GetOfficerListBranchToken: listData,
	};
	const url = `${API_URL}getAllOfficerUserBasedonBranchAutoLoan`;
	return makeApiCall(url, data);
};
/*********************** GET BRANCH OFFICER LIST (AutoLoan) END *********************/

/*********************** GET OFFICER CENTER LIST (AutoLoan) START *********************/
export const officerCenterListGetAutoLoan = (listData: any) => {
	const data = {
		GetOfficerListCenterToken: listData,
	};
	const url = `${API_URL}getCenterListBasedOnOfficerBranchAutoLoan`;
	return makeApiCall(url, data);
};
/*********************** GET OFFICER CENTER LIST (AutoLoan) END *********************/

/*********************** GET LOAN GROUP LIST (AutoLoan) START *********************/
export const loanGroupListGetAutoLoan = (listData: any) => {
	const data = {
		GetLoanGroupListToken: listData,
	};
	const url = `${API_URL}getGroupBasedLoanIndexAutoLoan`;
	return makeApiCall(url, data);
};
/*********************** GET LOAN GROUP LIST (AutoLoan) END *********************/

/*********************** UPDATE CHANGE GROUP OFFICER LIST (AutoLoan) START *********************/
export const ChangeGroupOfficerListUpdateAutoLoan = (listData: any) => {
	const data = {
		ChangeGroupOfficerDataToken: listData,
	};
	const url = `${API_URL}updateGroupOfficerAutoLoan`;
	return makeApiCall(url, data);
};
/*********************** UPDATE CHANGE GROUP OFFICER LIST (AutoLoan) END *********************/